<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-for="item in tabList"
        :label="item.label"
        :name="item.name"
        :key="item.label"
      ></el-tab-pane>
    </el-tabs>
    <el-row class="contentWrapper">
      <el-col :xs="24" :sm="14" class="leftCard">
        <AppDrag
          v-for="item in tabList"
          :key="item.name"
          v-show="activeName == item.name"
          :sourceType="item.name"
          :selectList="selectList"
          :styleCode="styleCode"
          :deployContent="deployContent"
          :blockId="blockId"
          :moduleCode="moduleCode"
        ></AppDrag>
      </el-col>
      <el-col :xs="24" :sm="10" class="rightCard">
        <div>提交信息：</div>
        <div class="summitContent borderA">
          <AppReceiverFixCount
            v-if="isFixedStyleCode"
            ref="appReceiverRef"
            :selectList.sync="selectList"
            :styleCode="styleCode"
            :deployContent="deployContent"
            class="selectList"
          ></AppReceiverFixCount>
          <AppReceiver
            v-else
            :styleCode="styleCode"
            v-model="selectList"
            class="selectList"
          ></AppReceiver>
        </div>
        <div class="optionArea">
          <el-button
            type="primary"
            @click="addLocation"
            v-if="this.styleCode === 106 && this.deployContent == 1"
            >添加位置</el-button
          >
          <el-button type="primary" @click="handleSubmit">保存</el-button>
          <el-button type="danger" @click="handleClear">清空</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import AppDrag from "@/components/deploy2/AppDrag";
import AppReceiver from "@/components/deploy2/AppReceiver";
import AppReceiverFixCount from "@/components/deploy2/AppReceiverFixCount";
import { getPageConfigDetail, savePageConfig } from "@/api/ozBlockConf";
import { getCompanyId, IsURL } from "@/common/utils/utils";
import { sourceTypeList, sourceTypeList1 } from "@/common/constant/constant";
export default {
  name: "keywordsAd",
  components: { AppDrag, AppReceiver, AppReceiverFixCount },
  props: [
    "blockConfId",
    "blockId",
    "styleCode",
    "deployNum",
    "moduleCode",
    "deployContent",
  ],
  data() {
    return {
      activeName: "app",
      selectList: [],
      tabList: sourceTypeList,
      tabList1: sourceTypeList1,
    };
  },
  computed: {
    /**固定位广告代码集 */
    isFixedStyleCode() {
      return this.styleCode === 201 || this.styleCode === 106;
    },
  },
  created() {
    if (this.styleCode === 106) {
      this.tabList = sourceTypeList.filter((e) => e["id"] === 0);
    }
    console.log(this.deployNum, this.styleCode, this.deployContent, "是多少");
    this.getKeywordAdDetail(this.blockConfId);
  },
  methods: {
    addLocation() {
      this.selectList.push({
        imgUrl: "",
        webUrl: "",
        radio: 1,
        isChecked: false,
        dragList: [],
      });
    },
    handleSubmit() {
      this.keywordAdAdd();
    },
    handleClear() {
      // this.selectList = [];
      if (!this.isFixedStyleCode) {
        this.selectList = [];
      } else {
        let arr = [];
        for (var i = 0; i < this.selectList.length; i++) {
          let obj = {
            imgUrl: "",
            webUrl: "",
            radio: 1,
            isChecked: false,
            dragList: [],
          };
          if (this.styleCode === 106 && i === 0) {
            obj.radio = 3;
          }
          arr.push(obj);
        }
        this.selectList = arr;
      }
    },
    async getKeywordAdDetail(id) {
      let res = await getPageConfigDetail({
        blockConfId: id,
      });
      const list = res.data || [];
      console.log(list, "获取的列表数据");
      this.selectList = list.map((item, i) => {
        item.apkName = item.apkName || item.app?.apkName;
        item.sourceType = this.tabList1.find(
          (tl) => tl.id == item.resType
        )?.name;
        if (this.isFixedStyleCode) {
          // if (item.resType == 1001 || item.resType == 1002) {
          //   item.dragList = [{ resName: item.resName, resType: item.resType }];
          // } else {
          item.dragList = [
            {
              apkId: item.apkId,
              apkName: item.apkName,
              packageName: item.packageName,
              iconUrl: item.iconUrl,
              webUrl: item.webUrl,
              isChecked: item.isChecked == 1 ? true : false,
            },
          ];
          // 只有在推广API模式下，第一个位置才强制设置为推广
          if (this.styleCode === 106 && i === 0 && this.deployContent == 2) {
            item.radio = 3;
          } else {
            item.radio = item.webUrl ? 2 : 1;
          }
          // }
        }
        item.isChecked = item.isChecked == 1 ? true : false;
        // forceChecked: 1表示true，0表示false
        if (item.forceChecked !== undefined) {
          item.forceChecked = item.forceChecked == 1 ? true : false;
        }
        return item;
      });
      // 默认循环指定数量数据
      // if (this.styleCode == 201 && this.selectList.length <= 0) {
      //   for (var i = 0; i < this.deployNum; i++) {
      //     this.selectList.push({
      //       imgUrl: "",
      //       webUrl: "",
      //       radio: 1,
      //       dragList: [],
      //     });
      //   }
      // }
      let selectListNum = this.selectList.length;
      let deployNum;
      if (this.isFixedStyleCode && selectListNum <= 0) {
        deployNum = this.deployNum; //获取设置的条数
        console.log(deployNum, selectListNum, "获取的条数");
        // 类型为开屏时，默认两个位置
        if (this.styleCode === 106 && this.deployContent == 2) {
          this.selectList.push(
            {
              imgUrl: "",
              webUrl: "",
              radio: 3,
              isChecked: false,
              dragList: [],
            },
            {
              imgUrl: "",
              webUrl: "",
              radio: 1,
              isChecked: false,
              dragList: [],
            }
          );
        } else {
          for (var i = 0; i < deployNum; i++) {
            this.selectList.push({
              imgUrl: "",
              webUrl: "",
              radio: 1,
              isChecked: false,
              dragList: [],
            });
          }
        }
      } else if (this.isFixedStyleCode && selectListNum < this.deployNum) {
        deployNum = this.deployNum - selectListNum;
        for (var j = 0; j < deployNum; j++) {
          this.selectList.push({
            imgUrl: "",
            webUrl: "",
            radio: 1,
            isChecked: false,
            dragList: [],
          });
        }
      } else if (this.isFixedStyleCode && selectListNum > this.deployNum) {
        if (this.styleCode == "106") {
          // this.selectList = this.selectList.slice(0, this.deployNum);
        } else {
          this.selectList = this.selectList.slice(0, this.deployNum);
        }
      }
    },
    async keywordAdAdd() {
      // 如果是FixedStyleCode，从子组件获取格式化后的数据
      const selectListData = this.isFixedStyleCode
        ? this.$refs.appReceiverRef.getFormattedList()
        : this.selectList;

      const list = selectListData.map((item, index) => {
        if (!item.resType) {
          item.resType =
            getCompanyId(item.sourceType) == 0
              ? 1
              : getCompanyId(item.sourceType);
        }

        item.blockConfId = this.blockConfId;
        item.site = index + 1;

        if (item.dragList && item.dragList.length > 0 && item.radio == 1) {
          item = { ...item, ...item.dragList[0] };
        }
        if (item.radio == 1) {
          item.webUrl = "";
          if (
            item.dragList &&
            item.dragList.length > 0 &&
            item.dragList[0].apkId
          ) {
            item.resType = 1;
          }
        }
        if (item.resTypeParams) {
          item.resType = item.resTypeParams; //1001推广-装机必备 推广-推荐位1002
        }
        // if (
        //   item.dragList &&
        //   item.dragList.length > 0 &&
        //   item.dragList[0].apkId
        // ) {
        //   item.resType = 1;
        // }
        if (item.radio == 2) {
          item.resType = 2001; //2001 外部链接
        } else if (item.radio == 3) {
          item.resType = 3007;
        }
        return item;
      });
      const data = {
        blockConfId: this.blockConfId,
        list,
      };
      // 图片合集校验
      if (this.isFixedStyleCode) {
        const isValid = list.some((item, i) => {
          // if (
          //   !item.imgUrl ||
          //   (item.radio == 2 && !item.webUrl) ||
          //   (item.radio == 1 && !item.dragList[0].apkId)
          // ) {
          //   return true;
          // }

          if (this.styleCode === 106 && i === 0) {
            return false;
          }

          if (
            !item.imgUrl ||
            (item.radio == 2 && !item.webUrl) ||
            (item.radio == 1 &&
              !item.dragList[0].apkId &&
              !item.dragList[0].resType)
          ) {
            return true;
          }
        });
        if (isValid) {
          this.$message.error("请检查数据是否填写完整");
          return;
        }
        let isNetwork = list.every((item, i) => {
          if (this.styleCode === 106 && i === 0) {
            return true;
          }

          return (item.radio == 2 && IsURL(item.webUrl)) || item.radio == 1;
        });
        if (!isNetwork) {
          this.$message.error("请输入正确链接");
          return;
        }
      }
      data.list.forEach((element, index) => {
        if (element.isChecked) {
          data.list[index].isChecked = 1;
        } else {
          data.list[index].isChecked = 2;
        }
        // forceChecked: true转为1，false转为0
        if (element.forceChecked !== undefined) {
          data.list[index].forceChecked = element.forceChecked ? 1 : 0;
        }
      });
      if (this.styleCode == 105 && data.list.length < 4) {
        this.$message.error("专栏图最少部署四条");
        return;
      }
      const appList = data.list.filter(
        (item) => item.sourceType != "promotion"
      );
      if (this.blockId == "52" && appList.length < 10) {
        this.$message.error("请至少部署10个应用");
        return;
      }
      // styleCode == 106 时，检查应用和外部链接是否重复
      if (this.styleCode === 106) {
        const apps = [];
        const webUrls = [];

        for (let i = 0; i < data.list.length; i++) {
          const item = data.list[i];

          // 检查应用是否重复（radio == 1）
          if (item.radio == 1 && item.apkId) {
            if (apps.includes(item.apkId)) {
              this.$message.error(
                `位置${i + 1}的应用与其他位置重复，请重新选择`
              );
              return;
            }
            apps.push(item.apkId);
          }

          // 检查外部链接是否重复（radio == 2）
          if (item.radio == 2 && item.webUrl) {
            if (webUrls.includes(item.webUrl)) {
              this.$message.error(
                `位置${i + 1}的外部链接与其他位置重复，请重新输入`
              );
              return;
            }
            webUrls.push(item.webUrl);
          }
        }
      }
      if (this.deployContent == 1 && this.styleCode === 106) {
        data.blockId = "12";
      }
      const res = await savePageConfig(data);
      if (res) {
        this.$message.success("部署成功");
        this.$emit("closeBtn");
      }
    },
  },
};
</script>

<style lang="scss">
.contentWrapper {
  height: 400px;
  .leftCard,
  .rightCard {
    height: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
  }
  .rightCard {
    display: flex;
    flex-direction: column;
    padding: 10px;
    .summitContent {
      flex: 1;
      margin: 10px 0;
      overflow: auto;
      .selectList {
        height: 100%;
      }
    }
    .optionArea {
      text-align: end;
    }
    .itemArea {
      width: 95%;
    }
  }
}
</style>
